/**
 * 智能客服 - 消息额外信息接口
 */
import { apiGet, apiPost } from '@/utils/request';

export interface MessageExtra {
  id: number;
  extra?: {
    /** AI 消息回复路径（消息气泡左侧"路径"标签 popover 数据源） */
    reply_path?: string;
  };
}

export const messagesApi = {
  getExtra: (id: number | string, params?: Record<string, unknown>) =>
    apiGet<MessageExtra>(`/messages/${id}/extra`, params),
  /** 查看单条消息明文；每次调用均由后端记录审计日志 */
  revealPii: (id: number | string) =>
    apiPost<{ id: number; content: string }>(`/messages/${id}/pii-reveal`),
};
